import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
import { toolkitCx } from "../../../constants/classnames";
import Image from "../../atoms/Image";
import Text from "../../atoms/Text";
/**
 * A button for selecting a wallet.
 *
 * @component
 *
 * @param {IWalletButton} props The component props.
 * @param {boolean} [props.isSelected=false] Whether the wallet is selected or not.
 * @param {TInitialApi} props.wallet The wallet object to display.
 * @param {KnownCip30WalletId} props.walletId The wallet ID.
 * @param {function} props.onClick The function to call when the button is clicked.
 *
 * @returns {JSX.Element} The rendered `WalletButton` component.
 */
const WalletButton = ({ isSelected, onClick, wallet, walletId, }) => {
    return (_jsxs("button", { "aria-label": `Wallet: ${walletId}`, className: cx("group", "w-full cursor-pointer select-none", "flex flex-col items-center justify-center gap-2", "rounded-lg shadow-md", "border-transparent dark:border-gray-600", toolkitCx.layout.border.hoverable, toolkitCx.layout.border.weight.default, toolkitCx.layout.spacing.both.md, toolkitCx.layout.transition.default, toolkitCx.recipes.scaleWhenActive, {
            "!border-primary-200/50 bg-primary/20": isSelected,
        }), onClick: onClick, children: [_jsx(Image, { src: wallet.icon, className: "h-6 w-6" }), _jsx(Text, { className: "capitalize", tag: "p", size: "xs", children: wallet.name })] }));
};
export default WalletButton;
//# sourceMappingURL=WalletButton.js.map